import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { OlPdfAcceptanceComponent } from 'src/app/components/ol-pdf-acceptance/ol-pdf-acceptance.component';
import { PdfService } from 'src/app/services/pdf.service';

@Component({
  selector: 'hr-digital-acceptance-modal',
  templateUrl: './digital-acceptance-modal.component.html',
  styleUrls: ['./digital-acceptance-modal.component.scss'],
})
export class DigitalAcceptanceModalComponent implements OnInit {
  @ViewChild('olPdfAcceptance') olPdfAcceptance!: OlPdfAcceptanceComponent;

  public formGroup: FormGroup;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<DigitalAcceptanceModalComponent>,
    private pdfService: PdfService,
    private snackbar: MatSnackBar
  ) {
    this.formGroup = this.fb.group({
      proposalAccepted: [false, [Validators.required]],
    });
  }

  ngOnInit(): void {}

  async save() {
    this.dialogRef.close(true);
  }

  closeModal() {
    this.dialogRef.close(false);
  }
}